var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8012 30.3875C11.8012 30.3875 0.908203 21.2135 0.908203 12.1865C0.908203 9.00392 2.17249 5.95168 4.42292 3.70124C6.67336 1.45081 9.72561 0.186523 12.9082 0.186523C16.0908 0.186523 19.143 1.45081 21.3935 3.70124C23.6439 5.95168 24.9082 9.00392 24.9082 12.1865C24.9082 21.2135 14.0152 30.3875 14.0152 30.3875C13.4092 30.9455 12.4117 30.9395 11.8012 30.3875ZM12.9082 17.4365C13.5976 17.4365 14.2803 17.3007 14.9173 17.0369C15.5543 16.7731 16.133 16.3863 16.6205 15.8988C17.108 15.4113 17.4947 14.8326 17.7586 14.1956C18.0224 13.5587 18.1582 12.876 18.1582 12.1865C18.1582 11.4971 18.0224 10.8144 17.7586 10.1774C17.4947 9.54048 17.108 8.96172 16.6205 8.47421C16.133 7.9867 15.5543 7.59999 14.9173 7.33615C14.2803 7.07232 13.5976 6.93652 12.9082 6.93652C11.5158 6.93652 10.1805 7.48965 9.19589 8.47421C8.21133 9.45878 7.6582 10.7941 7.6582 12.1865C7.6582 13.5789 8.21133 14.9143 9.19589 15.8988C10.1805 16.8834 11.5158 17.4365 12.9082 17.4365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ff88456ac156a11ba6201c3c0c7dbc4e.svg";
export { ForwardRef as ReactComponent };